import React from 'react';
import VerifyGiftcardOwnerRedirect from './VerifyGiftcardOwnerRedirect';
import { SALES_CHANNELS } from '../../constants';
import { setSalesChannel } from '../../actions/config';

const action = async ({ store }, { salesChannelId }) => {
  const {
    config: { salesChannelId: storeSalesChannelId },
  } = store.getState();

  if (salesChannelId && salesChannelId !== storeSalesChannelId) {
    await store.dispatch(setSalesChannel(salesChannelId));
  }

  return {
    title: 'Checking previous giftcard',
    chunks: ['verify-giftcard-owner-redirect'],
    component: <VerifyGiftcardOwnerRedirect />,
    salesChannelId: salesChannelId || SALES_CHANNELS.REDEEM,
    addCompanyMarkup: true,
  };
};

export default action;
